import { DataSourceCalculation } from "../../api/models/DataSource";
import Typography from "../Typography";
import EmissionsFactorTimelineItem from "./EmissionsFactorTimelineItem";
import EmissionsFactorTimelineSpacer from "./EmissionsFactorTimelineSpacer";

type EmissionsFactorTimelineGroupProps = {
    year: number;
    calculations: DataSourceCalculation[];
    isFirstTimelineGroup: boolean;
    isLastTimelineGroup: boolean;
};

const EmissionsFactorTimelineGroup = ({
    year,
    calculations,
    isFirstTimelineGroup,
    isLastTimelineGroup,
}: EmissionsFactorTimelineGroupProps) => {
    return (
        <>
            <div className="flex gap-12">
                <div className="hidden sm:flex flex-col items-center ml-4">
                    <div className="w-8" />
                    {!isFirstTimelineGroup && (
                        <div className="flex-1 w-px bg-surface-dark" />
                    )}
                </div>
                <div className="flex-1 pb-4">
                    <Typography variant="title-medium" component="p">
                        {year !== 0 ? year : "Initial"}
                    </Typography>
                </div>
            </div>
            {calculations.map((calculation, index) => (
                <EmissionsFactorTimelineItem
                    isInitialTimelineItem={index === 0 && isFirstTimelineGroup}
                    isLastTimelineItem={
                        index === calculations.length - 1 && isLastTimelineGroup
                    }
                    {...calculation}
                    key={`timline-item-${calculation.id}`}
                />
            ))}
            {!isLastTimelineGroup && (
                <EmissionsFactorTimelineSpacer size="large" />
            )}
        </>
    );
};

export default EmissionsFactorTimelineGroup;
